import {ComputedRef, inject, InjectionKey, Ref, WritableComputedRef} from "vue";
import {
    OperatorApplicationDialogTextareaModelInterface
} from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaModelInterface";
import OperatorApplicationTextareaSuggestInterface
    from "~/operatorApplication/vue/dialogs/dialog/suggestedTemplates/OperatorApplicationTextareaSuggestInterface";

export default function () {
    return inject(TextareaButtonInjectionKey);
}

export const TextareaButtonInjectionKey: InjectionKey<{
    client: ComputedRef<OperatorApplicationApi.OperatorApplicationClientOpenApiModel>,
    site: ComputedRef<OperatorApplicationApi.OperatorGetParamsSiteOpenApiModel>,
    showFreeDialogForSite: () => boolean,
    listenShortcut: (event: string, callback: (payload: any) => void) => void,
    focusTextarea: () => void,
    model: WritableComputedRef<OperatorApplicationDialogTextareaModelInterface>,
    currentDialog: ComputedRef<OperatorApplicationApi.OperatorApplicationClientCurrentDialogOpenApiModel | null>,
    uploadOnChange: (file: { response: any }) => void,
    uploadAction: ComputedRef<string>,
    uploadVoiceAction: ComputedRef<string>,
    startVoiceRecord: () => void,
    startVoiceTranscribe: () => void,
    isFree: ComputedRef<boolean>,
    isCopilotAvailableByTarif: ComputedRef<boolean>,
    sendMessage: (delayTimestamp?: number, sticker?: OperatorApplicationApi.OperatorApplicationStickerOpenApiModel) => void,
    uploadCount: Ref<number>,
    lastSelectedTemplateText: ComputedRef<string>,
    isCopilotRunning: Ref<boolean>,
    showCopilotTimeoutError: () => void,
    toggleCopilotRunning: (value: boolean) => void,
    onTemplateSelect: (template: OperatorApplicationApi.OperatorGetParamsMessageTemplateOpenApiModel, replace?: boolean) => void,
    setReplyToMessageId: (messageId?: number) => void,
    selectedAnswerChannel: ComputedRef<OperatorApplicationApi.OperatorApplicationAnswerChannelOpenApiModel | null>,
    resetTextareaSelection: () => void,
    closeDialog: (needConfirm?: boolean) => void,
    markAsRithoric: (needConfirm?: boolean) => void,
    suggestedTemplates: Ref<OperatorApplicationTextareaSuggestInterface[]>,
    selectedSuggestedTemplate: Ref<OperatorApplicationTextareaSuggestInterface>,
    setSuggestedTemplates: () => void,
    onSuggestedTemplateSelect: (template: OperatorApplicationTextareaSuggestInterface) => void,
}> = Symbol();
